export default __webpack_public_path__ + "static/media/funeral.56aa95c5.mp4";